import { Flex, Tabs } from "@mantine/core";
import { useContext, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";
import { IconSettings, IconColumns3, IconTicket } from "@tabler/icons-react";
import Settings from "../components/Registrations/Settings";
import CreateCustomField from "../components/Registrations/CreateCustomField";
import CustomFieldsList from "../components/Registrations/CustomFieldList";
import CreateTicketType from "../components/Registrations/CreateTicketType";
import TicketTypesList from "../components/Registrations/TicketTypeList";
import { useGetEvent } from "../api/event";

function RegistrationForm() {
  const { user } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    searchParams.get("tab") || "settings"
  );

  const currentEventId = getCurrentWorkspace(user).eventId;

  const { data: event, isPending } = useGetEvent(currentEventId);

  if (isPending || !event) {
    return null;
  }

  return (
    <Tabs
      value={activeTab}
      onChange={setActiveTab}
      keepMounted={true}
      variant="outline"
    >
      <Tabs.List>
        <Tabs.Tab value="settings" leftSection={<IconSettings size={16} />}>
          Settings
        </Tabs.Tab>

        <Tabs.Tab value="customFields" leftSection={<IconColumns3 size={16} />}>
          Custom Fields
        </Tabs.Tab>

        <Tabs.Tab value="ticketTypes" leftSection={<IconTicket size={16} />}>
          Ticket Types
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel
        value="settings"
        style={{ flex: 1, overflowY: "auto", padding: 16 }}
      >
        <Settings event={event} />
      </Tabs.Panel>

      <Tabs.Panel
        value="customFields"
        style={{ flex: 1, overflowY: "auto", padding: 16 }}
      >
        <Flex direction="column" gap="md">
          <CreateCustomField event={event} />
          <CustomFieldsList event={event} />
        </Flex>
      </Tabs.Panel>

      <Tabs.Panel
        value="ticketTypes"
        style={{ flex: 1, overflowY: "auto", padding: 16 }}
      >
        <Flex direction="column" gap="md">
          <CreateTicketType event={event} />
          <TicketTypesList event={event} />
        </Flex>
      </Tabs.Panel>
    </Tabs>
  );
}

export default RegistrationForm;
